import {Injectable} from '@angular/core';
import {Role} from '../models/role';
import {SnackBarIconService} from '../shared/snack-bar-icon/snack-bar-icon.service';
import {AngularFireFunctions} from '@angular/fire/compat/functions';
import {TeamRoleMember} from '../models/team-role-member';
import {FormControl, FormGroup, Validators, FormBuilder} from '@angular/forms';
import {MatDialog} from '@angular/material/dialog';
import {MatTableDataSource} from '@angular/material/table';
import {AngularFirestore} from '@angular/fire/compat/firestore';
import {ConfirmComponent} from '../shared/dialogs/confirm/confirm.component';

@Injectable({
  providedIn: 'root'
})
export class TeamService {

  public spinner: boolean = false;

  public roles: Role[] = []
  public members: any[] = []

  public teamEvent: TeamRoleMember[] = []
  public teamEventDataSource: MatTableDataSource<any>

  public teamDay: TeamRoleMember[] = []
  public teamDayDataSource: MatTableDataSource<any>

  public teamActivity: TeamRoleMember[] = []
  public teamActivityDataSource: MatTableDataSource<any>

  public teamTopic: TeamRoleMember[] = []
  public teamTopicDataSource: MatTableDataSource<any>

  constructor (
    private dialog: MatDialog,
    private db: AngularFirestore,
    private fb: FormBuilder,
    private ff: AngularFireFunctions,
    private snackBar: SnackBarIconService,
  ) { }

  loadTeamEvent (teamEvent) {
    if (teamEvent) {
      this.teamEvent = teamEvent
      this.teamEventDataSource = new MatTableDataSource(this.teamEvent)
    }
  }

  loadTeamDay (teamDay) {
    if (teamDay) {
      this.teamDay = teamDay
      this.teamDayDataSource = new MatTableDataSource(this.teamDay)
    }
  }

  loadTeamActivity (teamActivity) {
    if (teamActivity) {
      this.teamActivity = teamActivity
      this.teamActivityDataSource = new MatTableDataSource(this.teamActivity)
    }
  }

  loadTeamTopic (teamTopic) {
    if (teamTopic) {
      this.teamTopic = teamTopic
      this.teamTopicDataSource = new MatTableDataSource(this.teamTopic)
    }
  }

  /*
  loadRolesAndMembers() {
    const getRolesAndMembers = this.ff.functions.httpsCallable('getRolesAndMembers');
    return getRolesAndMembers()
      .then((querySnapshot) => {
        this.roles = querySnapshot.data.roles
        this.members = querySnapshot.data.members
      })
      .catch((error) => {
        return error
      })
  }
  */

  loadRolesAndMembers () {
    const getRolesAndMembers = this.ff.httpsCallable('getRolesAndMembers');
    return getRolesAndMembers({}).subscribe({
      next: (querySnapshot) => {
        this.roles = querySnapshot.data.roles;
        this.members = querySnapshot.data.members;
      },
      error: (error) => {
        console.error('Erro ao carregar dados:', error);
        // Você pode fazer algo com o erro aqui, como mostrar uma mensagem para o usuário.
      },
      complete: () => {
        // Opcional: este callback é chamado quando a operação é concluída.
        console.log('Operação de carregamento de dados completa.');
      }
    });
  }

  createTeamRoleForm () {
    let form: FormGroup = this.fb.group({
      id: new FormControl(''),
      member_id: new FormControl('', [ Validators.required ]),
      role_id: new FormControl('', [ Validators.required ]),
    });

    return form
  }

  addTeamRole (collection_id, collection_name, member_id, role_id) {

    console.log(member_id)
    console.log(role_id)

    this.spinner = true;

    let member = this.members.find((e) => {
      return e.id == member_id
    })

    let role = this.roles.find((e) => {
      return e.id == role_id
    })

    let teamRoleMember: TeamRoleMember = new TeamRoleMember()
    teamRoleMember.id = new Date().getTime().toString()
    teamRoleMember.member_id = member.id
    teamRoleMember.member_name = member.name
    teamRoleMember.role_id = role.id
    teamRoleMember.role_name = role.name

    switch (collection_name) {
      case "sbccv_events":
        let tempDataEvent: any[] = [];
        this.teamEvent.push(teamRoleMember)
        tempDataEvent = this.teamEvent
        if (this.teamEventDataSource) {
          this.teamEventDataSource.data = tempDataEvent;
        } else {
          this.teamEventDataSource = new MatTableDataSource(this.teamEvent)
        }
        this.updateTeam(collection_id, collection_name, this.teamEvent)
        break;

      case "sbccv_event_days":
        let tempDataDay: any[] = [];
        this.teamDay.push(teamRoleMember)
        tempDataDay = this.teamDay
        if (this.teamDayDataSource) {
          this.teamDayDataSource.data = tempDataDay;
        } else {
          this.teamDayDataSource = new MatTableDataSource(this.teamDay)
        }
        this.updateTeam(collection_id, collection_name, this.teamDay)
        break;

      case "sbccv_event_activities":
        let tempDataActivity: any[] = [];
        this.teamActivity.push(teamRoleMember)
        tempDataActivity = this.teamActivity
        if (this.teamActivityDataSource) {
          this.teamActivityDataSource.data = tempDataActivity;
        } else {
          this.teamActivityDataSource = new MatTableDataSource(this.teamActivity)
        }
        this.updateTeam(collection_id, collection_name, this.teamActivity)
        break;

      case "sbccv_event_topics":
        let tempDataTopic: any[] = [];
        this.teamTopic.push(teamRoleMember)
        tempDataTopic = this.teamTopic
        if (this.teamTopicDataSource) {
          this.teamTopicDataSource.data = tempDataTopic;
        } else {
          this.teamTopicDataSource = new MatTableDataSource(this.teamTopic)
        }
        this.updateTeam(collection_id, collection_name, this.teamTopic)

        let dt = this.teamTopicDataSource.data
        this.teamTopicDataSource.data = dt;
        break;

    }

  }

  removeTeamRole (collection_id, collection_name, element) {

    let dialogRef = this.dialog.open(ConfirmComponent, {
      width: '350px',
      height: '270px',
      panelClass: 'custom-dialog-container',
      data: {title: "Confirme", message: element.teamRole_name + "/" + element.member_name + "<br><br>Deseja excluir?"}
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result == "ok") {

        switch (collection_name) {
          case "sbccv_events":
            this.teamEvent = this.teamEvent.filter((e) => {
              return e.id != element.id
            })
            let tempDataEvent = this.teamEventDataSource.data
            tempDataEvent = this.teamEvent;
            this.teamEventDataSource.data = tempDataEvent;
            this.updateTeam(collection_id, collection_name, this.teamEvent)
            break;
          case "sbccv_event_days":
            this.teamDay = this.teamDay.filter((e) => {
              return e.id != element.id
            })
            let tempDataDay = this.teamDayDataSource.data
            tempDataDay = this.teamDay;
            this.teamDayDataSource.data = tempDataDay;
            this.updateTeam(collection_id, collection_name, this.teamDay)
            break;
          case "sbccv_event_activities":
            this.teamActivity = this.teamActivity.filter((e) => {
              return e.id != element.id
            })
            let tempDataActivity = this.teamActivityDataSource.data
            tempDataActivity = this.teamActivity;
            this.teamActivityDataSource.data = tempDataActivity;
            this.updateTeam(collection_id, collection_name, this.teamActivity)



            break;
          case "sbccv_event_topics":
            this.teamTopic = this.teamTopic.filter((e) => {
              return e.id != element.id
            })
            let tempDataTopic = this.teamTopicDataSource.data
            tempDataTopic = this.teamTopic;
            this.teamTopicDataSource.data = tempDataTopic;
            this.updateTeam(collection_id, collection_name, this.teamTopic)


            console.log("collection_name: " + collection_name)
            console.log("topic_id: " + collection_id)
            console.log("element.member_id: " + element.member_id)
            console.log("element.role_id: " + element.role_id)

            break;
        }


      }
    })
  }

  updateTeam (collection_id, collection_name, team) {

    // console.log("team: " + JSON.stringify(team))

    return this.db.collection(collection_name).doc(collection_id).set(JSON.parse(JSON.stringify({team: team})), {merge: true})
      .then(() => {

        this.snackBar.openSnackBar("Sucesso!", '', 'success');
      })
      .catch((error) => {
        console.log("event update error: " + JSON.stringify(error))
        let msgError: string = this.makeMsgError(error.details.code)
        this.snackBar.openSnackBar(msgError, '', 'error');
      })
      .finally(() => {
        this.spinner = false
      });
  }

  makeMsgError (errorsCode) {
    /*
    let msgError: string
        switch (errorsCode) {
          case "auth/email-already-exists":
            msgError = "Este email já está em uso"
            break;
        }
        return msgError
    */
    return errorsCode
  }

}
